import styles from './Layout.module.css';

export function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerInner}>
        <span className={styles.footerLogo}>TUBMarket</span>
        <span>Made with care · Ships from Bengaluru · hello@tubmarket.com</span>
      </div>
    </footer>
  );
}
